$(function () {
    $.ajax({
        url: `${window.api}/objects`,
        type: "GET",
        headers: {
            Authorization: 'Bearer ' + window.iFrameToken
        },
        success: function (objects) {

            function createObjectLayers(objects) {
                const objectLayers = [];

                const layersOrder = [
                    "zold_felulet",
                    "parcella",
                    "autozhato_ut",
                    "jarhato_ut",
                    "beton_ut",
                    "burkolt_felszin",
                    "fold_ut",
                    "gyalog_ut",
                    "epulet",
                    "cserje",
                    "kut",
                    "fa",
                    "kút",
                    "pad",
                    "tabla",
                    "villanyoszlop",
                    "ajto",
                    "kerites",
                    "kapu"
                ];

                objects.forEach((object) => {
                    const layerIndex = objectLayers.findIndex((l) => l.type === object.type);
                    if (layerIndex === -1) {
                        objectLayers.push({
                            type: object.type,
                            color: object.color,
                            data: [object],
                        });

                    } else {
                        objectLayers[layerIndex].data.push(object);
                    }
                });
                objectLayers.sort((o1, o2) => layersOrder.indexOf(o1.type) - layersOrder.indexOf(o2.type))
                return objectLayers;
            }

            createObjectLayers(objects).forEach((layer) => {
                if (layer.type.length) {
                    window.widget.addLayer(layer.data, 1, {
                        borderColor: layer.color,
                        fillColor: layer.color,
                        layerName: layer.type,
                        ignoreClick: true
                    });

                    $('[data-layer]').each(function () {
                        window.widget.setLayerVisibility($(this).data('layer'), false)
                    });
                }

            });

        }
    })
});